var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("loader-container loader-container--" + _vm.size)},[_c('span',{class:("loader loader--" + _vm.color)})])}
var staticRenderFns = []

export { render, staticRenderFns }